export const RECIPIENT_DETAIL = 'RecipientDetail'
export const CORPORATION_DETAIL = 'CorporationDetail'
export const CORPORATIONS = 'Corporations'
